import PropTypes from 'prop-types';
// material
import {
  Card,
  CardHeader,
  CardContent,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core';

function getVMName(vm) {
  return vm;
}

VMInfo.propTypes = {
  vms: PropTypes.array
};

export default function VMInfo({ vms }) {
  return (
    <Card data-testid="vm-info" sx={{ height: '100%' }}>
      <CardHeader title="VMs" />
      <CardContent>
        <TableContainer component={Paper}>
          <Table aria-label="vm-table" size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vms.map((vm, i) => (
                <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    {getVMName(vm)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
